import classNames from 'classnames';
import type { ExternalLinkProps } from './ExternalLink.types';

const anchorLinkClasses =
  'tw:inline-flex tw:text-sq-theme-link tw:underline tw:underline-offset-2 tw:transition-colors' +
  ' hover:tw:text-sq-theme-dark focus-visible:tw:outline-none focus-visible:tw:ring-2 focus-visible:tw:ring-sq-theme-link focus-visible:tw:ring-offset-2';

const anchorIconClasses = '';

/** Label uses body text tokens that follow light mode and `.tw-dark`. */
const labelTextClasses = 'tw:text-sq-text-color tw:dark:text-sq-text-color-dark tw:shrink-0';

const anchorClassesByVariant = {
  link: anchorLinkClasses,
  icon: anchorIconClasses,
} as const;

/**
 * Renders an external anchor (`target="_blank"`, `rel="noopener"`) with optional leading label on the same line.
 */
export const ExternalLink = ({
  variant = 'link',
  label,
  href,
  children,
  extraClassNames = '',
  testId,
}: ExternalLinkProps) => {
  return (
    <>
      {label && <span className={labelTextClasses}>{label}</span>}
      <a
        href={href}
        target="_blank"
        rel="noopener"
        className={classNames(anchorClassesByVariant[variant], extraClassNames)}
        data-testid={testId}>
        {children}
      </a>
    </>
  );
};

export default ExternalLink;
